import { c as _c } from "react/compiler-runtime";
import { getValuesForSelectedOptions } from 'commons/productUtils';
import usePdpSelectedCustomizerTab from 'components/consumer/PDP/state/pdpSelectedCustomizerTab/usePdpSelectedCustomizerTab';
import usePDPOptions from 'components/consumer/PDP/state/context/usePDPOptions';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import usePDPPrice from 'data-hooks/usePDPPrice';
import useProductFavoriteV2 from '../useProductFavoriteV2';
import avo from '../../analytics/avo';
const usePDPAddProtectionPlanEvent = () => {
  const $ = _c(8);
  const {
    isFavorited
  } = useProductFavoriteV2();
  const {
    data: priceData
  } = usePDPPrice();
  const {
    data: optionData
  } = usePDPOptions();
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const pdpSelectedCustomizerTab = usePdpSelectedCustomizerTab();
  let t0;
  if ($[0] !== basicDetails || $[1] !== isFavorited || $[2] !== optionData || $[3] !== pdpSelectedCustomizerTab || $[4] !== priceData?.optionPrice || $[5] !== priceData?.price?.final_price || $[6] !== priceData?.price?.original_price) {
    const addProtectionPlanEvent = plan => {
      const {
        fabric
      } = getValuesForSelectedOptions(optionData.options, optionData.selectedOptions);
      avo.protectionPlanAdded({
        fabricColor: fabric?.color || "",
        fabricId: fabric?.id || 0,
        fabricName: pdpSelectedCustomizerTab === "decide-later" ? "Decide Later" : fabric?.value || "",
        favorited: isFavorited,
        fullPrice: parseFloat(typeof priceData?.price?.original_price !== "undefined" && priceData?.price?.original_price !== null ? (priceData?.price?.original_price || 0) + (priceData?.optionPrice || 0) : undefined),
        planPrice: parseFloat(plan.plan_price),
        planName: plan.plan_name === "Pet Protector Plan" ? "Pet Protector" : "Life Happens",
        price: parseFloat(typeof priceData?.price?.final_price !== "undefined" && priceData?.price?.final_price !== null ? (priceData?.price?.final_price || 0) + (priceData?.optionPrice || 0) : undefined),
        productFamily: basicDetails.family?.name,
        productId: basicDetails.id,
        location: "PDP",
        name: basicDetails.name,
        category: basicDetails.type.name,
        component: "Side Panel"
      });
    };
    t0 = {
      addProtectionPlanEvent
    };
    $[0] = basicDetails;
    $[1] = isFavorited;
    $[2] = optionData;
    $[3] = pdpSelectedCustomizerTab;
    $[4] = priceData?.optionPrice;
    $[5] = priceData?.price?.final_price;
    $[6] = priceData?.price?.original_price;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  return t0;
};
export default usePDPAddProtectionPlanEvent;